export function isObjectEmpty(obj) {
    return obj === null || obj === undefined || Object.keys(obj).length === 0;
}
//# sourceMappingURL=util.js.map